import { EventEmitter } from 'eventemitter3';

/**
 * Singleton event emitter for state updates.
 */
const stateEventEmitter = new EventEmitter();

export default stateEventEmitter;
